import React from 'react'
import Skeleton from "react-loading-skeleton";

const FacilitiesBannerSkeleton = () => {
  return (
    <div style={{ textAlign: "center", lineHeight: 1 }}>
      <Skeleton width={530} height={197} />
    </div>
  )
}

export default FacilitiesBannerSkeleton
